module.exports = __webpack_public_path__ + "@/assets/img/043-boy-18.793f5f49.svg";